module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employee/templates/payslips/View.ejs -->\n<div class="ibox-content js-payslip">\n    <a href="#payslips" class="previous-link">\n        <i class="fa fa-angle-left"></i>\n        Back to list</a>\n    <br/>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employee/templates/payslips/View.ejs
// module id = 1061
// module chunks = 1